/**
 * Cómo se le dice al operador el estado de una línea de WhatsApp. El backend guarda claves
 * (`EstadoLinea`: `qr_pendiente`, `desconectada`…) y el detalle de la campaña y el paso «Conectar»
 * las mostraban crudas: «qr_pendiente». Una sola tabla para que Líneas y esas pantallas digan lo mismo.
 */
const ETIQUETAS: Record<string, string> = {
  desconectada: "desconectada",
  conectando: "conectando…",
  qr_pendiente: "vinculando…",
  calentando: "calentando",
  activa: "activa",
  bloqueada: "bloqueada",
};

export function etiquetaEstadoLinea(estado?: string | null): string {
  const e = String(estado || "").trim();
  if (!e) return "sin estado";
  return ETIQUETAS[e] || e;
}
